import axios from 'axios';
class follow {
  constructor() {
    this.url = '/mall/app/follow';
  }

  pagequery(query) {
    return axios({
      url: `${this.url}/product`,
      method: 'get',
      params: query,
    });
  }
  follow(query) {
    return axios({
      url: `${this.url}/product`,
      method: 'post',
      data: query,
    });
  }
  cancellationProducts(query) {
    return axios({
      url: `${this.url}/product`,
      method: 'delete',
      data: query,
    });
  } 
  cancellationShops(query) {
    return axios({
      url: `${this.url}/store`,
      method: 'delete',
      data: query,
    });
  } 
  focusShops(query) {
    return axios({
      url: `${this.url}/store/${query}`,
      method: 'post',
      
    });
  }
  focusProducts(query) {
    return axios({
      url: `${this.url}/product`,
      method: 'post',
      data: query,
    });
  }
}
export default new follow();
